<template>
<div>
    <b-container v-if="brewer">
        <!------------------>
        <!-- Cart sidebar -->
        <!------------------>
        <div>
            <b-sidebar id="sidebar-cart" title="Cart" right shadow v-model="showSideBar" backdrop-variant="dark" backdrop>
                <Cartsidebar  />
            </b-sidebar>
        </div>

        <b-row>
            <b-col>
                <transition name="fade">
                        <div v-if="sendingMessage" class="loading">
                            <p>Sending Message...</p>
                        </div>
                </transition>

                <transition name="fade">
                    <div v-if="loadingPage" class="loading">
                        <p>Loading...</p>
                    </div>
                </transition>
            </b-col>
        </b-row>


         <!-- About the brewer -->
        <b-row class='row' style="margin-top: 10px; margin-bottom: 10px; margin-left:10px">
            <div v-if='brewer.logoFileURL' class='col-3'>
                <!-- FULL SIZE LOGO IS WRONG FOR DISTRIBUTORS. SHOWS BREWERY LOGO INSTEAD -->
                <img :src="brewer.logoFileThumbnailURL" width="200" fluid alt="Logo image" class="img-thumbnail">
                </div>
            
            <div class='col-8'>
                <div class="row">
                    <h1>{{brewer.company}}</h1>
                </div>
                <div  class="row">
                    <h4>{{brewer.address}}</h4>
                </div>

                <div class="row" style="margin-bottom:10px" v-if="showBrewerDetails&&brewer.abcLicenseNumber">
                    ABC License Number: {{brewer.abcLicenseNumber}}
                </div>

                <div class="row" style="margin-bottom:10px; color:green" v-if="showBrewerDetails&&brewer.deliveryMethod">
                    <h5>Distributor: {{brewer.deliveryMethod}}</h5>
                </div>
                
                <!-- License and sales sheet -->
                <div class="row">
                    <!-- License -->
                    <b-button v-if="showBrewerDetails&&brewer.licenseFileURL" v-b-modal.modal-license>Show License</b-button>
                    <b-modal  scrollable size="l" id="modal-license" title="License" ok-only ok-variant="secondary" ok-title="Close" hide-footer>
                        <img :src="brewer.licenseFileURL"  fluid alt="Logo image" class="img-thumbnail">
                    </b-modal>

                    <!-- Sales Sheet -->
                    <b-button v-if="brewer.salesSheetPdfUrl" v-b-modal.modal-salessheet style="margin-left:10px">Sales Sheet</b-button>
                    <b-modal  scrollable size="xl" id="modal-salessheet" title="Sales Sheet" ok-only ok-variant="secondary" ok-title="Close" hide-footer>
                        <pdf :src="brewer.salesSheetPdfUrl"></pdf>
                    </b-modal>
                </div>

            </div>
        </b-row>

        <!-- Description -->
        <b-row style="margin-top: 10px; margin-bottom: 10px; margin-left:10px; margin-right:10px">
            <b-col>
                <div v-for="(theline, index) in lines" :key='index'>
                    {{theline}}

                </div>
            </b-col>
        </b-row>

        <!-- Sign in, if no user -->
        <b-row v-if='!currentUser'>
            <b-col>
                <b-button size="lg" class="m-md-2" variant="info" @click="$router.push('/createaccount')">
                    Join Kegseeker To Order These Beverages
                </b-button>
            </b-col>
        </b-row>

            <!-- Send a message -->
            <b-row v-if="showBrewerDetails&&currentUser&&userProfile.isbrewer<=0">
                <b-col>
                    <sendmessage  :receiverId="brewerId" :receiverName="brewer.company" :arrayDefaultMessages="arrayDefaultMessages"/>
                </b-col>
            </b-row>
            <br>

            <!-- Request services -->
            <b-row>
                <b-col>
                    <b-button variant="info" v-b-modal.modal-servicerequest>Request Services</b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <small>Line cleaning, tap handles, keg pickup, signage</small>
                </b-col>
            </b-row>
            <b-modal id="modal-servicerequest" title="Create Service Requests" size="xl" hide-footer
                header-bg-variant="info" header-text-variant="light">
                <servicerequests :brewersLists='getBrewersList' @closeServicesModal="closeServicesModal" />
            </b-modal>
            <br>

        <b-row>
            <beercomponent v-for="beer in brewerInventory" :beer="beer" :key="beer.id"  :shouldShowSearch=0 :showCartSidebar="showCartSidebar" :selected="beer.selected"/>
        </b-row>

        
    </b-container>
    <footer v-if="showBrewerDetails"><pagefooter/></footer>
</div>
</template>

<script>
    import { mapState } from 'vuex'
    const fb = require('../firebaseConfig.js')
    import Sendmessage from './Sendmessage'
    import Pagefooter from './Pagefooter'
    import Beertable from './Beertable'
    import pdf from 'vue-pdf'
    import Beercomponent from './Beercomponent'
    import Cartsidebar from './buyer/Cartsidebar'
    import Servicerequests from './buyer/Servicerequests'

    export default {
        //distbrewerid needed for distributor to check which distributor brewery was clicked
        props: ['brewerId', 'distbrewerid'],
        components: {
            Sendmessage,
            Pagefooter,
            Beertable,
            pdf,
            Beercomponent,
            Cartsidebar,
            Servicerequests,
            },

        data() {
            return {
                showSuccess: false,
                brewer:{
                    company:'',
                    address:'',
                    about:'',
                    logoFileURL:'',
                },
                changingBreweryFromProfile:false,
                selectedBrewerId:'',
                brewerInventory:[],
                theMessage:'',
                sendingMessage:false,
                loadingPage: false,
                addedToCart:false,
                shortName:'',
                showBrewerDetails:true,
                arrayDefaultMessages:[
                    'Send me some samples',
                    'Let me know the status of my order'
                ],
                viewingFromDirectLink:false,
                //When buyer clicked a beer from email
                selectedBeerId:'',
                showSideBar:false,
            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser' , 'userCart', 'isBrewer', 'brewersList']),
            getBrewersList(){
                return [this.brewer]
            },

            lines() { 

                if(this.brewer.description){
                    var allLines = this.brewer.description.split('\n')
                    return allLines
                }
                else return
                } ,

        },
        methods: {

            getuidFromShortName(){
                console.log("Finnding uid for shortname = " + this.shortName)
                fb.usersCollection.where('shortName', '==', this.shortName).onSnapshot(querySnapshot => {
                        querySnapshot.forEach(doc => {
                            let brewer = doc.data()
                            brewer.brewerid=doc.id
                            this.brewerId = doc.id
                            this.getBrewerProfile()
                            
                        })
            
                    })
            },

            getBrewerProfile() {
                this.loadingPage = true
                this.$store.commit('setDataLoadingInStoreStatus',true)

                fb.usersCollection.doc(this.brewerId).get().then(res => {
                    try{
                        this.brewer = res.data()
                        this.brewer.address = res.data().street1
                        this.brewer.brewerid=res.id
                        
                        if (res.data().street2){
                            this.brewer.address  = this.brewer.address  + ' ' + res.data().street2
                        }
                        this.brewer.address  = this.brewer.address  + ', ' + res.data().city + ', ' + res.data().state + ', ' + res.data().zip
                        if(res.data().logoFileThumbnailURL) this.brewer.logoFileThumbnailURL=res.data().logoFileThumbnailURL
                        else  this.brewer.logoFileThumbnailURL=""
                        //this.loadingPage=false
                        this.getInventoryForBrewer()

                    }
                    catch{
                        console.log("Error getting brewery profile for brewerid="+this.brewerId)
                        this.loadingPage = false
                    }

            }).catch(err => {
                this.loadingPage = false
                console.log(err)
            })
                
            },
            getInventoryForBrewer(){
                this.brewerInventory = []
                //Raw downloaded inventory array
                let inventoryArray = []

                var brewerIdField = 'uid'
                var fbref = fb.beersCollection
                //Beer is under uid for brewery and distributorId for distributor
                /*
                if (this.brewer.isbrewer == 2){
                    brewerIdField = 'distributorId'
                    fbref=fb.distributorBeersCollection
                }*/ 
                this.$store.commit('setDataLoadingInStoreStatus',true)

                fbref.where(brewerIdField, '==', this.brewerId).get().then(docs => {
                    this.loadingPage=false
                    docs.forEach(doc => {
                        let theBeerData = doc.data()
                        theBeerData.docId = doc.id
                        theBeerData.email = this.brewer.email
                        theBeerData.createdOn=""
                        theBeerData.createdTime=""

                        //Need to check if quantity exists and is greater than zero. Need to do this as some of these might not exist, causing NaN
                        var barrel1Quantity = 0; var barrel2Quantity = 0; var canQuantity = 0; var bottleQuantity = 0; 
                        if (theBeerData.barrel1Quantity>0&&!isNaN(theBeerData.barrel1Quantity)) barrel1Quantity = theBeerData.barrel1Quantity
                        if (theBeerData.barrel2Quantity>0&&!isNaN(theBeerData.barrel2Quantity)) barrel2Quantity = theBeerData.barrel2Quantity
                        if (theBeerData.canQuantity>0&&!isNaN(theBeerData.canQuantity)) canQuantity = theBeerData.canQuantity
                        if (theBeerData.bottleQuantity>0&&!isNaN(theBeerData.bottleQuantity)) bottleQuantity = theBeerData.bottleQuantity

                        //Get available quantity for multisize
                        var beerAvalQuantity = 0
                        if(theBeerData.multiSize == 1) beerAvalQuantity = Math.max(barrel1Quantity, barrel2Quantity, canQuantity, bottleQuantity)

                        //Get available quantity for old non-multisize
                        else{
                            //check that number is valid
                            if (theBeerData.quantity>0&&!isNaN(theBeerData.quantity))
                            beerAvalQuantity = theBeerData.quantity
                            } 

                        //Check if this beer was selected by user from email etc
                        if (theBeerData.id==this.selectedBeerId) theBeerData.selected=true
                        else theBeerData.selected=false

                        //For consumers, add only if consumers allowed
                        if(this.userProfile.isbrewer==-1){
                            if (theBeerData.allowConsumers=='1'){
                                if(beerAvalQuantity>0 )inventoryArray.push(theBeerData)
                            }
                        }
                        else if(beerAvalQuantity>0) inventoryArray.push(theBeerData)

                        this.$store.commit('setDataLoadingInStoreStatus',false)


                    })
                }).then(res => {

                        //This is the array which will set this.brewerInventory after sorting etc
                        var sortedBrewerInventory=[]

                        //Check if this was a distributor. If distributor, sort beers by brewery name
                        //Function to compare brewery name
                        function compare(a, b) {
                            const brewerA = a.brewer.toLowerCase();
                            const brewerB = b.brewer.toLowerCase();
                            let comparison = 0;
                            if (brewerA >brewerB) {
                                comparison = 1;
                                } else if (brewerA<brewerB) {
                                            comparison = -1;
                                }
                                return comparison;
                            }
                            
                        //Check if distributor page
                        if(this.brewer.isbrewer==2){
                            console.log("Distro id = " + this.brewerId)
                            //Sort by brewery name
                            inventoryArray.sort(compare);
                            //If user arrived here by clicking a brewery name, push that breweries inventory to the top
                            if(this.distbrewerid){
                                console.log("Came from distributor brewery")
                                //Iterate over beers, move the ones matching distbrewerid to top
                                for (var j=0; j<inventoryArray.length; j++){
                                    var thisBeer=inventoryArray[j]
                                    if(thisBeer.distbrewerid==this.distbrewerid) sortedBrewerInventory.unshift(thisBeer)
                                    else sortedBrewerInventory.push(thisBeer)

                                }
                                
                            }
                            else sortedBrewerInventory=inventoryArray
                        }
                        else sortedBrewerInventory=inventoryArray

                        this.brewerInventory = sortedBrewerInventory
                        this.loadingPage=false
                        this.$store.commit('setDataLoadingInStoreStatus',false)
                    })
                .catch(err => {
                console.log(err)
                this.$store.commit('setDataLoadingInStoreStatus',false)
                this.loadingPage=false
            })
            //this.loadingPage=false

            },
            //Toggle cart sidebar
            showCartSidebar(){
                this.showSideBar=true
            },

            //Close services modal
            closeServicesModal(){
                this.$bvModal.hide("modal-servicerequest")
            }
        },

        mounted(){

            if(this.$route.params.beerid ){
                console.log("Beer id = " + this.$route.params.beerid )
                this.selectedBeerId = this.$route.params.beerid 
            }

            if(this.brewerId){
                this.viewingFromDirectLink = false
                this.getBrewerProfile()
            }
            else if (this.$route.params.brewershortname ){
                this.showBrewerDetails = false
                this.shortName  = this.$route.params.brewershortname 
                this.viewingFromDirectLink = true
                this.getuidFromShortName()
            }
        }

    }
</script>